export default "/fonts/vendor/@coreui/icons/CoreUI-Icons-Brand.ttf?78f24b4d601bec22f00347112a88b746";